$(".comparative-card-center").on("mouseover", function () {
  $(".comparative-card-left .card-img-top").addClass("move-left");
  $(".comparative-card-right .card-img-top").addClass("move-right");
});

$(".comparative-card-center").on("mouseleave", function () {
  $(".comparative-card-center").addClass("z1");
  $(".comparative-card-left .card-img-top").removeClass("move-left");
  $(".comparative-card-right .card-img-top").removeClass("move-right");
  setTimeout(() => {
    $(".comparative-card-center").removeClass("z1");
  }, 500);
});

$(".comparative-card-left").on("mouseover", function () {
  $(".comparative-card-center").addClass("z1");
  $(".comparative-card-center .card-img-top").addClass("move-right");
  $(".comparative-card-right .card-img-top").addClass("move-right");
});

$(".comparative-card-left").on("mouseleave", function () {
  $(".comparative-card-left").addClass("z1");
  $(".comparative-card-center .card-img-top").removeClass("move-right");
  $(".comparative-card-right .card-img-top").removeClass("move-right");
  setTimeout(() => {
    $(".comparative-card-center").removeClass("z1");
    $(".comparative-card-left").removeClass("z1");
  }, 500);
});

$(".comparative-card-right").on("mouseover", function () {
  $(".comparative-card-center").addClass("z1");
  $(".comparative-card-center .card-img-top").addClass("move-left");
  $(".comparative-card-left .card-img-top").addClass("move-left");
});

$(".comparative-card-right").on("mouseleave", function () {
  $(".comparative-card-right").addClass("z1");
  $(".comparative-card-center .card-img-top").removeClass("move-left");
  $(".comparative-card-left .card-img-top").removeClass("move-left");
  setTimeout(() => {
    $(".comparative-card-center").removeClass("z1");
    $(".comparative-card-right").removeClass("z1");
  }, 500);
});
